import { render, staticRenderFns } from "./BirthDateFilter.vue?vue&type=template&id=3ded58ac&scoped=true&"
import script from "./BirthDateFilter.vue?vue&type=script&lang=js&"
export * from "./BirthDateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded58ac",
  null
  
)

export default component.exports